export enum ZIndexMember {
  reqAmount = 1,
  svgCircle = 2,
  intercomWebview = 3,
  axeptioWidgetWebview = 4,
}
